<template>
    <div class="d-flex justify-content-center flex-wrap">
        <form @submit.prevent="applyChanges" class="col-12 col-lg-10 col-xl-6 d-flex flex-wrap" v-if="onEdit !== null && onDelete === false">
            <div class="col-12 mb-4">
                <h4 class="text-second">
                    {{ onEdit === false ? $t('Dashboard.Account.personal_data') : `${$t('Dashboard.EditAccountData.edit')} - ${$t('Dashboard.Account.personal_data')}`}}
                </h4>
            </div>
            <div class="col-12 d-flex justify-content-between flex-wrap bg-white border shadow rounded p-5 mb-4 section-loader" v-if="onEdit === false">
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap mb-2 mb-sm-0">
                    <span class="fw-bold">
                        {{ $t('Dashboard.Account.name') }}
                    </span>
                    <span>
                        {{ account.name }}
                    </span>
                </div>
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap mb-2 mb-sm-0">
                    <span class="fw-bold">
                        {{ $t('Dashboard.Account.surname') }}
                    </span>
                    <span>
                        {{ account.surname }}
                    </span>
                </div>
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap mb-2 mb-sm-0">
                    <span class="fw-bold">
                        {{ $t('Dashboard.Account.email') }}
                    </span>
                    <span class="text-break">
                        {{ account.email }}
                    </span>
                </div>
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap">
                    <span class="fw-bold">
                        {{ $t('Dashboard.Account.language') }}
                    </span>
                    <span>
                        {{ $t(`${account.languages_id}`) }}
                    </span>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-between flex-wrap bg-white border shadow rounded p-5 mb-4 section-loader" v-if="onEdit === true">
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap mb-4 mb-sm-0 form-field">
                    <label for="name" class="mb-2">
                        <small :class="{'text-danger' : errors.name}">
                            {{ $t('Dashboard.Account.name') }}
                        </small>
                        <span v-if="errors.name" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.name" class="text-danger">
                            {{ errors.name }}
                        </small>
                    </label>
                    <input name="name" type="text" v-model="name" class="form-control" id="name" :placeholder="$t('Dashboard.EditAccountData.insert_name')" :class="{'text-danger border-danger' : errors.name}">
                </div>
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap form-field">
                    <label for="surname" class="mb-2">
                        <small :class="{'text-danger' : errors.surname}">
                            {{ $t('Dashboard.Account.surname') }}
                        </small>
                        <span v-if="errors.surname" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.surname" class="text-danger">
                            {{ errors.surname }}
                        </small>
                    </label>
                    <input name="surname" type="text" v-model="surname" class="form-control" id="surname" :placeholder="$t('Dashboard.EditAccountData.insert_surname')" :class="{'text-danger border-danger' : errors.surname}">
                </div>
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-12 col-sm-5 mb-4 mb-sm-0">
                    <label for="email" class="mb-2">
                        <small>
                            {{ $t('Dashboard.Account.email') }}
                        </small>
                    </label>
                    <input name="email" type="email" :value="account.email" class="form-control" id="email" disabled>
                </div>
                <div class="col-12 col-sm-5">
                    <label for="language">
                        <small :class="{'text-danger' : errors.language}">
                            {{ $t('Dashboard.EditAccountData.language') }}
                        </small>
                        <span v-if="errors.language" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.language" class="text-danger">
                            {{ errors.language }}
                        </small>
                    </label>
                    <div>
                        <LanguagesSelect id="language" class="text-second" :class="{'text-danger' : errors.language}" @setLanguage="this.errors = {}"/>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
                <span class="btn btn-auth btn-auth-white" role="button" @click="onEdit = true" v-if="onEdit === false">
                    <i class="fa-regular fa-pen-to-square"></i>
                    {{ $t('Dashboard.Account.edit') }}
                </span>
                <span class="btn btn-danger" @click="onEdit = null, onDelete = true" v-if="onEdit === false">
                    <i class="fa-regular fa-trash-can"></i>
                    {{ $t('Dashboard.Account.deletion_request') }}
                </span>
                <span class="btn btn-auth btn-auth-white" role="button" @click="cancel" v-if="onEdit === true">
                    {{ $t('Dashboard.EditAccountData.cancel') }}
                </span>
                <button type="submit" class="btn btn-auth btn-auth-second" v-if="onEdit === true">
                    {{ $t('Dashboard.EditAccountData.apply') }}
                </button>
            </div>
        </form>
        <form @submit.prevent="sendDeletionRequest" class="col-12 col-lg-10 col-xl-6 d-flex flex-wrap" v-if="onEdit === null && onDelete === true">
            <div class="col-12 mb-4">
                <h4 class="text-second">
                    {{ `${$t('Dashboard.DeletionRequest.request')} - ${$t('Dashboard.Account.personal_data')}`}}
                </h4>
            </div>
            <div class="col-12 bg-white border shadow rounded p-5 mb-4 section-loader">
                <h5 class="text-danger">
                    {{ $t('Dashboard.DeletionRequest.notice') }}
                </h5>
            </div>
            <div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
                <span class="btn btn-auth btn-auth-white" role="button" @click="onEdit = false, onDelete = false">
                    {{ $t('Dashboard.DeletionRequest.cancel') }}
                </span>
                <button type="submit" class="btn btn-auth btn-danger">
                    {{ $t('Dashboard.DeletionRequest.send_request') }}
                </button>
            </div>
        </form>
        <form @submit.prevent="deletionConfirm" class="col-12 col-lg-10 col-xl-6 d-flex flex-wrap" v-if="onEdit === null && onDelete === 'on delete'">
            <div class="col-12 mb-4">
                <h4 class="text-second">
                    {{ `${$t('Dashboard.DeletionRequest.request')} - ${$t('Dashboard.Account.personal_data')}`}}
                </h4>
            </div>
            <div class="col-12 d-flex flex-wrap bg-white border shadow rounded p-5 mb-4 section-loader">
                <div class="col-12 mb-2">
                    <h5>
                        {{ $t('Dashboard.DeletionConfirm.otp_sended') }}
                    </h5>
                </div>
                <div class="col-12 mb-4">
                    <h5 class="text-first text-break">
                        {{ account.email }}
                    </h5>
                </div>
                <div class="col-12 col-sm-5 d-flex justify-content-between flex-wrap mb-4 form-field">
                    <label for="name" class="mb-2">
                        <small :class="{'text-danger' : errors.OTP}">
                            {{ $t('Dashboard.DeletionConfirm.otp') }}
                        </small>
                        <span v-if="errors.OTP" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.OTP" class="text-danger">
                            {{ errors.OTP }}
                        </small>
                    </label>
                    <input @focus="errors.OTP = null" type="text" name="OTP" v-model="OTP" class="form-control" id="OTP" :placeholder="$t('Dashboard.DeletionConfirm.otp')" :class="{'text-danger border-danger' : errors.OTP}" maxlength="6">
                </div>
                <div class="col-12">
                    <span class="text-danger text-uppercase">
                        {{ $t('Dashboard.DeletionConfirm.alert') }}
                    </span>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
                <span class="btn btn-auth btn-auth-white" role="button" @click="onEdit = false, onDelete = false">
                    {{ $t('Dashboard.DeletionRequest.cancel') }}
                </span>
                <button type="submit" class="btn btn-auth btn-danger">
                    {{ $t('Dashboard.DeletionConfirm.confirm') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'AccountView',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapState(['account']),
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            onEdit: false,
            onDelete: false,
            name: null,
            surname: null,
            OTP: null,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setAccount', 'setLoader']),
        cancel() {
            this.errors = {}
            if (this.account.name != this.name) {
                this.name = this.account.name
            }
            if (this.account.surname != this.surname) {
                this.surname = this.account.surname
            }
            if (this.account.languages_id != this.$i18n.locale) {
                this.$i18n.locale = this.account.languages_id
                localStorage.setItem('session_language', this.account.languages_id)
            }
            this.onEdit = false
        },
        applyChanges() {
            this.setLoader(true)
            this.errors = {}
            var account = {
                id: this.account.id,
                name: this.name,
                surname: this.surname,
                language: this.$i18n.locale,
                notify_ticket_issuance: true
            }
            
            this.$http
                .post(`${this.apiPath}/edit`, { account }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    this.setLoader(false)
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'account.name') {
                                this.errors.name = this.$t(`Dashboard.EditAccountData.errors.name.${error.msg}`)
                            }
                            if (error.path == 'account.surname') {
                                this.errors.surname = this.$t(`Dashboard.EditAccountData.errors.surname.${error.msg}`)
                            }
                            if (error.path == 'account.language') {
                                this.errors.language = this.$t(`Dashboard.EditAccountData.errors.language.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.account) {
                        this.setAccount(res.data.account)
                        this.$toast.success(this.$t('Dashboard.AccountDataChangesSucceeded.succeeded'))
                        this.onEdit = false
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                    this.setLoader(false)
                })
        },
        sendDeletionRequest() {
            this.onDelete = 'on delete'
            this.$http
                .post(`${this.apiPath}/deletion_request`, { id: this.account.id }, {
                    headers: {
                        "x-api-key": this.omsApiKey,
                    }
                })
                .then(() => {
                    this.$toast.success(this.$t('toast.deletion_request_sended'))
                })
                .catch((err) => {
                    this.setErrorFromServer(err)
                })
        },
        deletionConfirm() {
            this.setLoader(true)
            this.$http
                .post(`${this.apiPath}/deletion_confirm`, { id: this.account.id, OTP: this.OTP }, {
                    headers: {
                        "x-api-key": this.omsApiKey,
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'OTP') {
                                this.errors.OTP = this.$t(`Dashboard.DeletionConfirm.errors.OTP.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        this.setLoader(false)
                        return
                    }
                    switch (res.data) {
                        case 'Invalid OTP':
                            this.errors.OTP = this.$t('Dashboard.DeletionConfirm.errors.OTP.invalid')
                            this.$toast.error(this.$t('Dashboard.DeletionConfirm.errors.OTP.invalid'))
                            this.setLoader(false)
                            break;
                        default:
                            this.$toast.success(`<h4>${this.$t('Dashboard.AccountDeleted.deleted')}</h4> ${this.$t('Dashboard.AccountDeleted.disconnection')}`)
                            setTimeout(() => {
                                this.$store.dispatch('logout')
                            }, 1500)
                            break;
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err)
                })
        }
    },
    created() {
        this.name = this.account.name
        this.surname = this.account.surname
    }
}
</script>

<style lang="scss" scoped>
    .section-loader {
        animation: loading 0.5s linear;

        @keyframes loading {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }
</style>